function BulkOperationReportIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='45' height='45' viewBox='0 0 45 45' fill='none'>
      <rect width='45' height='45' rx='12' fill='#ECE9F2' />
      <g clipPath='url(#clip0_36069_132524)'>
        <path
          d='M32.0455 16.8182C32.5705 16.8182 33 17.2477 33 17.7727V32.0909C33 33.1409 32.1409 34 31.0909 34H16.7727C16.2477 34 15.8182 33.5705 15.8182 33.0455C15.8182 32.5205 16.2477 32.0909 16.7727 32.0909H30.1364C30.6614 32.0909 31.0909 31.6614 31.0909 31.1364V17.7727C31.0909 17.2477 31.5205 16.8182 32.0455 16.8182ZM13.9091 13H27.2727C28.3227 13 29.1818 13.8591 29.1818 14.9091V28.2727C29.1818 29.3227 28.3227 30.1818 27.2727 30.1818H13.9091C12.8591 30.1818 12 29.3227 12 28.2727V14.9091C12 13.8591 12.8591 13 13.9091 13ZM14.8636 28.2727H26.3182C26.8432 28.2727 27.2727 27.8432 27.2727 27.3182V15.8636C27.2727 15.3386 26.8432 14.9091 26.3182 14.9091H14.8636C14.3386 14.9091 13.9091 15.3386 13.9091 15.8636V27.3182C13.9091 27.8432 14.3386 28.2727 14.8636 28.2727Z'
          fill='#402080'
        />
        <path
          d='M20.6407 17.1268L18.136 19.6315C17.8488 19.9188 18.0463 20.4036 18.4502 20.4036H20.0572V24.8923C20.0572 25.386 20.4612 25.79 20.9549 25.79C21.4487 25.79 21.8527 25.386 21.8527 24.8923V20.4036H23.4596C23.8636 20.4036 24.0611 19.9188 23.7738 19.6405L21.2691 17.1358C21.0986 16.9563 20.8113 16.9563 20.6407 17.1268Z'
          fill='#402080'
        />
      </g>
      <defs>
        <clipPath id='clip0_36069_132524'>
          <rect width='24' height='24' fill='white' transform='matrix(-1 0 0 1 35 11)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default BulkOperationReportIcon
